import { BASE_URL } from '../../config'
import { REQ_PAYMENT, SET_DISBURSE_LIST, SET_ERROR_DISBURSE, SET_PAYMENT_LIST, SET_ERROR_PAYMENT, REQ_DISBURSE } from "../../utils/constants/actionTypes";
import {GTransDisbursment, GTransRepayment} from '../../config/api'

export const Disbursement = (ClientID) => async (dispatch) => {
    dispatch({type : REQ_DISBURSE});
    try{
        let res = await fetch(`${BASE_URL}${GTransDisbursment}`, {
            method : 'GET',
            credentials: 'include',
            headers : { 
                'X-Client-ID' : ClientID,
                'Content-Type' : "application/json"
            }
        })
        
        let hasil = await res.json()
        if( res.status === 200 ){
            dispatch({ type: SET_DISBURSE_LIST, payload : hasil.result.transactions })
        } else{
            dispatch({ type: SET_ERROR_DISBURSE, payload : hasil.status.message});
            console.log('1. Error DISBURSE : ', hasil.status.message)
        }
    } catch(err){
        dispatch({ type: SET_ERROR_DISBURSE, payload : err.message});
        console.log('2. Error DISBURSE : ', err.message);
    }
}

export const Repayment = (ClientID) => async (dispatch) => {
    dispatch({type : REQ_PAYMENT});
    try{
        let res = await fetch(`${BASE_URL}${GTransRepayment}`, {
            method : 'GET',
            credentials: 'include',
            headers : { 
                'X-Client-ID' : ClientID,
                'Content-Type' : "application/json"
            }
        })
        
        let hasil = await res.json()
        if( res.status === 200 ){
            dispatch({ type: SET_PAYMENT_LIST, payload : hasil.result.transactions })
        } else{
            dispatch({ type: SET_ERROR_PAYMENT, payload : hasil.status.message});
            console.log('1. Error PAYMENT : ', hasil.status.message)
        }
    } catch(err){
        dispatch({ type: SET_ERROR_PAYMENT, payload : err.message});
        console.log('2. Error PAYMENT : ', err.message);
    }
}

